import { createSelector } from '@ngrx/store';
import { AppState } from 'src/app/core/app.state';
import { AgentsState } from './agents.reducers';

export const selectAgentsState = (state: AppState) => state.agents;

// Agents selectors
export const selectAgents = createSelector(
  selectAgentsState,
  (state: AgentsState) => state.agents
);
export const selectAgent = createSelector(
  selectAgentsState,
  (state: AgentsState) => state.agent
);

// Commissions selectors
export const selectCommissions = createSelector(
  selectAgentsState,
  (state: AgentsState) => state.commissions
);
export const selectCommission = createSelector(
  selectAgentsState,
  (state: AgentsState) => state.commission
);